import styled from 'styled-components';
import { COLOR } from '@common/constants';

export const FormErrorMessage = styled.p`
  color: ${COLOR.ERROR_TEXT};
`;

export default FormErrorMessage;
